import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ljhf",
  "use": "icon-ljhf-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-ljhf\">\n<polyline stroke-width=\"1.5\" stroke-miterlimit=\"10\" points=\"14.594,7.032 10.98,2.941 7.699,7.05 \n\t4.242,2.803 0.824,7.137 \" />\n<polyline stroke-width=\"1.5\" stroke-miterlimit=\"10\" points=\"14.594,13.323 10.98,9.23 7.699,13.341 \n\t4.242,9.095 0.824,13.43 \" />\n<rect width=\"1.542\" height=\"16\" />\n<rect y=\"14.457\" width=\"16\" height=\"1.543\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol